import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const Text = styled.span`
  font-size: 10px;
  line-height: 1.6;
  padding: 0;
  height: 15px;
  width: 100%;
  text-align: center;
  color: ${({ theme }) => theme.flightLine.textColor};
  white-space: nowrap;
`;

export const LineArea = styled.div`
  position: relative;
  width: 80%;
`;

export const Line = styled.div`
  margin: 2px 0;
  width: 100%;
  height: 2px;
  background: ${({ theme }) => theme.flightLine.line};
`;

export const Points = styled.ul`
  display: flex;
  justify-content: space-around;
  position: absolute;
  top: 2px;
  width: 100%;
`;

export const Point = styled.li`
  height: 2px;
  width: 2px;
  border-radius: 1px;
  background: ${ColorPalette.HEX.White};
  box-shadow: ${({ theme }) => theme.flightLine.point};
`;
